import { Manifest } from '../types/manifest';

export const getSelectedFile = (id: string, files: Manifest[]): Manifest => {
    return files.find((file) => file.id === id) as Manifest;
};
